import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { morphAffix, formatMoney } from '../common';
import './ListPaymentStatistics.css';

const ListPaymentStatistics = ({
  balance, sumPayments, soldVisited, sumSoldVisited, currency
}) => {
  const balanceClasses = classNames({
    ListPaymentStatistics_Balance: true,
    ListPaymentStatistics_Balance__minus: balance < 0
  });
  return (
    <div className="ListPaymentStatistics_Wrapper">
      {(balance || balance === 0) && (<span><span className="ListPaymentStatistics_BalanceLabel">Баланс: </span>
      <span className={balanceClasses}>{formatMoney(balance)} {currency} </span>|</span>)}
      <span> Поступило платежей на </span>
      <span className="ListPaymentStatistics_Sum">{formatMoney(sumPayments)} {currency} </span>|
      Продано <span className="ListPaymentStatistics_Visited">{soldVisited}</span> {morphAffix(soldVisited, 'приход', 'прихода', 'приходов')} на сумму
      <span className="ListPaymentStatistics_SumSoldVisited"> {formatMoney(sumSoldVisited)} {currency}</span>
    </div>
  );
};

ListPaymentStatistics.defaultProps = {
  currency: '₽'
};

ListPaymentStatistics.propTypes = {
  balance: PropTypes.number,
  sumPayments: PropTypes.number.isRequired,
  soldVisited: PropTypes.number.isRequired,
  sumSoldVisited: PropTypes.number.isRequired,
  currency: PropTypes.string
};

export default ListPaymentStatistics;



// WEBPACK FOOTER //
// ./src/components/ListPaymentStatistics.js